import { EnvVarManager } from '@/env/envVarManager';
import { ILocalStorageKey } from '@/types/ILocalStorageKey';

const prefix = 'MY_POPPIES_B2B';
const environment = EnvVarManager.getEnvVar('NEXT_PUBLIC_APP_ENV');

export const getLocalStorageKey = (keyName: ILocalStorageKey): string => {
  return `${prefix}__${environment}__${keyName}`.toUpperCase();
};
